var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6471 10.4118H6.82353V7.11765C6.82353 4.26306 9.14541 1.94118 12 1.94118C14.8536 1.94118 17.1765 4.26306 17.1765 7.11765C17.1765 7.37741 17.3873 7.58824 17.6471 7.58824C17.9068 7.58824 18.1176 7.37741 18.1176 7.11765C18.1176 3.74447 15.3732 1 12 1C8.62682 1 5.88235 3.74447 5.88235 7.11765V10.4598C4.80941 10.6781 4 11.6287 4 12.7647V21.2353C4 22.5332 5.056 23.5882 6.35294 23.5882H17.6471C18.9449 23.5882 20 22.5332 20 21.2353V12.7647C20 11.4678 18.9449 10.4118 17.6471 10.4118ZM12.4706 17.8932V20.2941C12.4706 20.5539 12.2598 20.7647 12 20.7647C11.7402 20.7647 11.5294 20.5539 11.5294 20.2941V17.8932C10.4565 17.6748 9.64706 16.7242 9.64706 15.5882C9.64706 14.2904 10.7031 13.2353 12 13.2353C13.2969 13.2353 14.3529 14.2904 14.3529 15.5882C14.3529 16.7252 13.5435 17.6748 12.4706 17.8932Z",
    fill: "#000C36"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.d0bcd51e.svg";
export { ForwardRef as ReactComponent };